import { tokenService } from '@bedrock/fido-sdk';
import { errorAction } from '../error/error.actions';
import { ERROR_LEVELS, ERROR_TYPES } from '../error/error.constants';
import { setCurrentSectionCode } from '../layout/layout.section.actions';
import { setRouteSkeletonByEntity } from '../routing/routing.actions';
import { resetSearch } from '../search/search.reset.actions';
import { fetchProfileInfos } from '../user/user.actions';
import { clearUserProfile, renewTokenFailure, renewTokenSuccess, selectUserProfile } from '../pairing/pairing.actions';
import { renewToken } from './customer/default/token.actions';

/**
 * Select a specified profile as active for the current user.
 * @param profileUid profile to use
 */
export const renewJwtWithProfile = profileUid => async (dispatch, getState) => {
  try {
    const {
      layout: { requestedEntityId, requestedEntityType },
    } = getState();

    dispatch(selectUserProfile(profileUid));
    dispatch(setRouteSkeletonByEntity(requestedEntityType, requestedEntityId));

    tokenService.setProfile({ profileUid });

    return renewToken().then(() => {
      dispatch(renewTokenSuccess(profileUid));
      // NOTE: the section follows the profile infos, see the routing middleware
      dispatch(fetchProfileInfos(profileUid));
      dispatch(resetSearch());
    });
    // NOTE: the requested (unlocked) layout fetching will be done in the routing middleware
  } catch (error) {
    tokenService.setProfile(null);

    dispatch(renewTokenFailure(error));
    dispatch(errorAction(ERROR_LEVELS.SILENT, ERROR_TYPES.PAIRING, error.message));

    return Promise.resolve(null);
  }
};

/**
 * Reset the current profile, and prompt the user to select a new one.
 * We clear the current profile in Fido, and manually trigger a layout re-fetch, which causes the API to respond with the Profiles Gate page.
 */
export const resetJwtProfile = () => dispatch => {
  tokenService.setProfile(null);
  dispatch(setCurrentSectionCode('main'));
  dispatch(clearUserProfile());
};
